import { Tenant, User, Voice, VoiceCategory, AudioGeneration, AuditLog, ChurchMember } from './types';

export const MOCK_CATEGORIES: VoiceCategory[] = [
  {
    id: 'cat_standard',
    name: 'Standard Voices',
    slug: 'standard',
    description: 'Fast, crisp, clear reading ideal for scripture recaps and daily announcements.',
    creditMultiplier: 1.0,
    color: 'emerald',
  },
  {
    id: 'cat_premium',
    name: 'Premium Natural',
    slug: 'premium',
    description: 'Human-grade warmth and emotional cadence for pastoral devotionals.',
    creditMultiplier: 2.0,
    color: 'indigo',
  },
  {
    id: 'cat_ultra',
    name: 'Ultra-Expressive',
    slug: 'ultra',
    description: 'Deeply resonant, hyper-realistic tone for solemn liturgies and dramatic narrative.',
    creditMultiplier: 3.5,
    color: 'amber',
  },
  {
    id: 'cat_cloned',
    name: 'Leadership Voice Clones',
    slug: 'cloned',
    description: 'Authorized, custom voice clones of your leadership team.',
    creditMultiplier: 5.0,
    color: 'purple',
  },
];

export const MOCK_USERS: User[] = [
  {
    id: 'usr_super_admin',
    name: 'DoxaTech Super Admin',
    email: 'admin@doxatech.com',
    role: 'SUPER_ADMIN',
    avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=80',
  },
  {
    id: 'usr_pastor_john',
    name: 'Pastor John Mark',
    email: 'pastor.john@gracechurch.org',
    role: 'ADMIN',
    tenantId: 'ten_grace-church',
    tenantName: 'Grace Community Church',
    avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=80',
  },
  {
    id: 'usr_staff_sarah',
    name: 'Sarah Jenkins',
    email: 'sarah.media@gracechurch.org',
    role: 'USER',
    tenantId: 'ten_grace-church',
    tenantName: 'Grace Community Church',
    avatarUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&auto=format&fit=crop&q=80',
  },
];

export const MOCK_TENANTS: Tenant[] = [
  {
    id: 'ten_grace-church',
    name: 'Grace Community Church',
    slug: 'grace-church',
    role: 'ADMIN',
    creditsBalance: 245000,
  },
  {
    id: 'ten_hope-ministry',
    name: 'Hope Fellowship Global',
    slug: 'hope-ministry',
    role: 'ADMIN',
    creditsBalance: 120000,
  },
  {
    id: 'ten_new-life',
    name: 'New Life Chapel',
    slug: 'new-life',
    role: 'ADMIN',
    creditsBalance: 85000,
  },
];

export const MOCK_CHURCH_MEMBERS: ChurchMember[] = [
  {
    id: 'mem_1',
    name: 'Pastor John Mark',
    email: 'pastor.john@gracechurch.org',
    role: 'ADMIN',
    status: 'ACTIVE',
    joinedAt: '2026-01-10',
  },
  {
    id: 'mem_2',
    name: 'Sarah Jenkins',
    email: 'sarah.media@gracechurch.org',
    role: 'USER',
    status: 'ACTIVE',
    joinedAt: '2026-02-14',
  },
  {
    id: 'mem_3',
    name: 'David Keller',
    email: 'david.tech@gracechurch.org',
    role: 'USER',
    status: 'ACTIVE',
    joinedAt: '2026-03-01',
  },
  {
    id: 'mem_4',
    name: 'Grace Miller',
    email: 'grace.pastoral@gracechurch.org',
    role: 'USER',
    status: 'INVITED',
    joinedAt: '2026-09-20',
  },
];

export const MOCK_VOICES: Voice[] = [
  {
    "id": "v_david_us",
    "name": "David (American Reflective Scripture)",
    "description": "Warm and reflective American tone for Psalm meditations, prayer guides, and daily devotionals.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "David",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Algenib",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Algenib.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Warm",
      "Devotional",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": true
  },
  {
    "id": "v_joshua_us",
    "name": "Joshua (American Teaching & Exhortation)",
    "description": "Authoritative, clear theological teaching cadence for sermon recaps, discipleship, and podcast lessons.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Joshua",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Fenrir",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Fenrir.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Teaching",
      "Authoritative",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": true
  },
  {
    "id": "v_ruth_us",
    "name": "Ruth (American Calm Devotional)",
    "description": "Gentle, contemplative vocal persona for morning devotionals, communion reflections, and quiet prayer.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Ruth",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Aoede",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Aoede.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Devotional",
      "Contemplative",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": true
  },
  {
    "id": "v_mary_us",
    "name": "Mary (American Gentle Prayer)",
    "description": "Calm, comforting vocal persona designed for hospital visits, prayer messages, and grief support.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Mary",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Kore",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Kore.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Prayer",
      "Comforting",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": true
  },
  {
    "id": "v_timothy_us",
    "name": "Timothy (American Youth & Community)",
    "description": "Upbeat, high-engagement vocal delivery crafted for youth alerts, camp invitations, and vibrant updates.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Timothy",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Puck",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Puck.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Youth Ministry",
      "Vibrant",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_esther_us",
    "name": "Esther (American Clear Scripture)",
    "description": "Crisp, neutral American reading cadence engineered for Bible recitations and clarity in daily bulletins.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Esther",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Mimosa",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Mimosa.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Clear Reading",
      "Scripture",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_priscilla_us",
    "name": "Priscilla (American Narrative Storyteller)",
    "description": "Expressive narrative voice for Bible dramatizations, parables, and engaging Sunday school lessons.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Priscilla",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Thalassa",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Thalassa.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Narrative",
      "Storytelling",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_stephen_us",
    "name": "Stephen (American Broadcast Announcements)",
    "description": "Clear, commanding American voice for Sunday reminders, community notices, and tithes updates.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Stephen",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Regulus",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Regulus.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Announcements",
      "Broadcast",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_matthew_us",
    "name": "Matthew (American Devotional Reader)",
    "description": "Natural, conversational American cadence for podcast devotionals, fellowship recaps, and weekly bulletins.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Matthew",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Castor",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Castor.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Conversational",
      "Bulletins",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_barnabas_us",
    "name": "Barnabas (American Encouragement & Outreach)",
    "description": "Heartfelt, encouraging American vocal delivery for volunteer appreciation and community reach-out.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Barnabas",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Sadalmelik",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Sadalmelik.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Encouragement",
      "Outreach",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_deborah_us",
    "name": "Deborah (American Prophetic Scripture)",
    "description": "Strong, inspiring American tone for prophetic Scripture readings and prayer vigils.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Deborah",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Sulafat",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Sulafat.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Scripture",
      "Inspiring",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_gideon_us",
    "name": "Gideon (American Exhortation & Courage)",
    "description": "Resolute American tone for men fellowship conferences and courage devotionals.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Gideon",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Kuma",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Kuma.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Exhortation",
      "Courage",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_abigail_us",
    "name": "Abigail (American Wisdom & Peace)",
    "description": "Gentle, wise American vocal delivery for peaceful evening prayers and family devotionals.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Abigail",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Capella",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Capella.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Wisdom",
      "Peaceful",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_nathan_us",
    "name": "Nathan (American Narrative Scripture)",
    "description": "Conversational expressive narration for devotions, podcast clips, and Bible reading.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Nathan",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "INWORLD",
    "providerVoiceId": "inworld-pastor-narrative",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/inworld/inworld-pastor-narrative.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Narrative",
      "Inworld AI"
    ],
    "isFavorite": false
  },
  {
    "id": "v_chloe_us",
    "name": "Chloe (American Youth & Community)",
    "description": "Engaging, modern conversational voice for student ministry, youth announcements, and camps.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Chloe",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "INWORLD",
    "providerVoiceId": "inworld-youth-minister",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/inworld/inworld-youth-minister.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Youth",
      "Dynamic",
      "Inworld AI"
    ],
    "isFavorite": false
  },
  {
    "id": "v_caleb_faith_us",
    "name": "Caleb (American Faith & Resolution)",
    "description": "Strong, steady American cadence for faith affirmations and Sunday morning encouragement.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Caleb",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Rasalgethi",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Rasalgethi.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Faith",
      "Steady",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_hannah_prayer_us",
    "name": "Hannah (American Heartfelt Prayer)",
    "description": "Deeply heartfelt American feminine tone for intercessory prayer meetings and family altar audio.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Hannah",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Gemma",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Gemma.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Intercessory",
      "Prayer",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_jonathan_us",
    "name": "Jonathan (American Covenant & Brotherhood)",
    "description": "Warm, sincere brotherly tone for fellowship groups and youth mentoring devotionals.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Jonathan",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Spica",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Spica.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Brotherhood",
      "Fellowship",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_lydia_us",
    "name": "Lydia (American Marketplace & Hospitality)",
    "description": "Articulate, professional American delivery for workplace faith devotionals and hospitality ministries.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Lydia",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Electra",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Electra.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Marketplace",
      "Hospitality",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_philip_us",
    "name": "Philip (American Evangelism & Outreach)",
    "description": "Direct, clear, and compelling American tone for evangelistic pamphlets and seeker outreach.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Philip",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Castula",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Castula.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Evangelism",
      "Outreach",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_phoebe_us",
    "name": "Phoebe (American Compassion & Service)",
    "description": "Gentle, gracious American feminine delivery for benevolent ministries and hospice care audio.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Phoebe",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Maia",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Maia.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Compassion",
      "Service",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_silas_us",
    "name": "Silas (American Midnight Praise)",
    "description": "Resilient and uplifting American voice for praise exhortations and spiritual breakthrough prayers.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Silas",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Antares",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Antares.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Praise",
      "Breakthrough",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_dorcas_us",
    "name": "Dorcas (American Lovingkindness)",
    "description": "Motherly, comforting American vocal delivery for grief support, hospital ministries, and benevolent care.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Dorcas",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Taygeta",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Taygeta.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Lovingkindness",
      "Care",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_titus_us",
    "name": "Titus (American Leadership & Integrity)",
    "description": "Clear, steadfast American voice for biblical leadership training and elder discipleship lessons.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Titus",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Achernar",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Achernar.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Leadership",
      "Discipleship",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_rachel_us",
    "name": "Rachel (American Gentle Benediction)",
    "description": "Peaceful, melodic American reading tone for evening benedictions and family scripture reflections.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Rachel",
    "gender": "FEMALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Celaeno",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Celaeno.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Benediction",
      "Peaceful",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_samuel_gb",
    "name": "Samuel (British Liturgical Orator)",
    "description": "Deep, resonant, solemn liturgical cadence for formal Scripture readings and cathedral worship.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Samuel",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Charon",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Charon.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Liturgical",
      "Solemn",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_hannah_gb",
    "name": "Hannah (British Contemplative Devotional)",
    "description": "Reflective, clear British English delivery for evening prayers, meditations, and Psalm readings.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Hannah",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Leda",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Leda.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Contemplative",
      "Psalms",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_grace_gb",
    "name": "Grace (British Cathedral Reader)",
    "description": "Solemn, cathedral-grade British reading cadence for formal liturgies and scripture narration.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Grace",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Erinome",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Erinome.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Cathedral",
      "Solemn",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_arthur_gb",
    "name": "Arthur (British Solemn Scripture)",
    "description": "Awe-inspiring, timeless British cadence for formal scripture reading and liturgy.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Arthur",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "ELEVENLABS",
    "providerVoiceId": "AZnzlk1XvdvUeBnXmlld",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/elevenlabs/AZnzlk1XvdvUeBnXmlld.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Liturgy",
      "Solemn"
    ],
    "isFavorite": false
  },
  {
    "id": "v_elizabeth_gb",
    "name": "Elizabeth (British Classical Scripture)",
    "description": "Refined, articulate British English voice suited for classical Scripture recitation.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Elizabeth",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Bellatrix",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Bellatrix.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Classical",
      "Articulate",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_peter_gb",
    "name": "Peter (British Exhortation & Boldness)",
    "description": "Dynamic and persuasive British English voice for evangelistic call-to-actions and missional appeals.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Peter",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Aldebaran",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Aldebaran.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Bold",
      "Evangelistic",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_andrew_gb",
    "name": "Andrew (British Choral Evensong)",
    "description": "Reverent Oxford-style cadence for evensong litanies, creeds, and devotional podcasts.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Andrew",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Rigel",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Rigel.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Choral",
      "Reverent",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_philip_gb",
    "name": "Philip (British Classical Liturgy)",
    "description": "Deep, steady British tone for Book of Common Prayer readings and sacred liturgies.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Philip",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Betelgeuse",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Betelgeuse.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Liturgy",
      "Book of Common Prayer",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_miriam_gb",
    "name": "Miriam (British Hymn Reader)",
    "description": "Melodic British feminine voice for reading Christian poetry, sacred hymns, and spiritual biographies.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Miriam",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alcyone",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alcyone.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Hymns",
      "Poetry",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_john_gb",
    "name": "John (British High Church Lector)",
    "description": "Resonant, distinguished British reader for formal epistle and gospel pulpit readings.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "John",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Procyon",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Procyon.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Pulpit Reading",
      "Distinguished",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_eleanor_gb",
    "name": "Eleanor (British Parish Devotionals)",
    "description": "Warm, relatable British countryside accent for daily parish updates and community prayer groups.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Eleanor",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Sterope",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Sterope.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Parish",
      "Warm",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_charles_gb",
    "name": "Charles (British Theological Lecture)",
    "description": "Scholarly, articulate British academic tone for seminary audio courses and apologetics lectures.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Charles",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alnilam",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alnilam.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Theological",
      "Academic",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_victoria_gb",
    "name": "Victoria (British Royal Chapel Reader)",
    "description": "Regal, precise British vocal timbre suited for ceremonial church gatherings and national days of prayer.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Victoria",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Merope",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Merope.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Ceremonial",
      "Precise",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_edward_gb",
    "name": "Edward (British Solemn Psalter)",
    "description": "Poignant, reflective British English voice for solemn psalmody and evening meditation.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Edward",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Mintaka",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Mintaka.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Psalms",
      "Solemn",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_beatrice_gb",
    "name": "Beatrice (British Morning Collects)",
    "description": "Gentle, uplifting British feminine voice for early morning prayer collects and liturgical readings.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Beatrice",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Pleione",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Pleione.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Morning Prayer",
      "Collects",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_george_gb",
    "name": "George (British Celtic Exhortation)",
    "description": "Rich Celtic/Scottish-inflected British delivery bringing warmth to covenant blessings.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "George",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Dubhe",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Dubhe.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Celtic",
      "Warmth",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_margaret_gb",
    "name": "Margaret (British Abbey Meditations)",
    "description": "Deeply peaceful British monastic vocal quality for silent retreat reflections and contemplative prayer.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Margaret",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Asterope",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Asterope.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Monastic",
      "Peaceful",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_william_gb",
    "name": "William (British Discipleship Guide)",
    "description": "Direct, inspiring British voice designed for men Bible studies and discipleship modules.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "William",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Merak",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Merak.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Discipleship",
      "Inspiring",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_catherine_gb",
    "name": "Catherine (British Evensong Reflection)",
    "description": "Graceful, calming British female voice for dusk prayer services and twilight scripture listening.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Catherine",
    "gender": "FEMALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Atlas",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Atlas.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Evensong",
      "Calming",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_henry_gb",
    "name": "Henry (British Classical Homily)",
    "description": "Articulate, classic English delivery suitable for expository homilies and doctrinal statements.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Henry",
    "gender": "MALE",
    "accent": "British",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Phecda",
    "language": "en-GB",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Phecda.mp3",
    "status": "ACTIVE",
    "tags": [
      "British Accent",
      "Homily",
      "Expository",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_fola_ng",
    "name": "Fola (West African / Nigerian English)",
    "description": "Warm, articulate West African / Nigerian cadence powered by Gemini 3.8 Flash TTS for sermons, weekly announcements, and devotionals.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Fola",
    "gender": "FEMALE",
    "accent": "Nigerian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Fola",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Fola.mp3",
    "status": "ACTIVE",
    "tags": [
      "Nigerian Accent",
      "West African",
      "Gemini 3.8 Flash TTS",
      "Warm",
      "Devotional"
    ],
    "isFavorite": false
  },
  {
    "id": "v_daniel_za",
    "name": "Daniel (South African English)",
    "description": "Rich, resonant South African English cadence for uplifting worship exhortations and regional church broadcasts.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Daniel",
    "gender": "MALE",
    "accent": "South African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Vega",
    "language": "en-ZA",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Vega.mp3",
    "status": "ACTIVE",
    "tags": [
      "South African Accent",
      "African English",
      "Gemini 3.8 Flash TTS",
      "Resonant"
    ],
    "isFavorite": false
  },
  {
    "id": "v_lydia_ke",
    "name": "Lydia (East African / Kenyan English)",
    "description": "Inspiring, joyful East African / Kenyan English cadence for mission testimonies and community thanksgiving.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Lydia",
    "gender": "FEMALE",
    "accent": "Kenyan",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Autonoe",
    "language": "en-KE",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Autonoe.mp3",
    "status": "ACTIVE",
    "tags": [
      "Kenyan Accent",
      "East African",
      "Gemini 3.8 Flash TTS",
      "Inspiring"
    ],
    "isFavorite": false
  },
  {
    "id": "v_silas_af",
    "name": "Silas (African English Devotional)",
    "description": "Thoughtful, steady African English voice for morning devotionals, family prayer guides, and Bible study audio.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Silas",
    "gender": "MALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Hesperos",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Hesperos.mp3",
    "status": "ACTIVE",
    "tags": [
      "African Accent",
      "Gemini 3.8 Flash TTS",
      "Devotional",
      "Steady"
    ],
    "isFavorite": false
  },
  {
    "id": "v_joseph_af",
    "name": "Joseph (African English Inspiration)",
    "description": "Inspiring and uplifting African English voice for faith testimonies, leadership conferences, and Sunday school lessons.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Joseph",
    "gender": "MALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Canopus",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Canopus.mp3",
    "status": "ACTIVE",
    "tags": [
      "African Accent",
      "Gemini 3.8 Flash TTS",
      "Inspirational",
      "Youth"
    ],
    "isFavorite": false
  },
  {
    "id": "v_titus_af",
    "name": "Titus (West African Clear Scripture)",
    "description": "Crisp, reverent West African English delivery for reading New Testament epistles and church announcements.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Titus",
    "gender": "MALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Meissa",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Meissa.mp3",
    "status": "ACTIVE",
    "tags": [
      "African Accent",
      "Gemini 3.8 Flash TTS",
      "Scripture Reading",
      "Clear"
    ],
    "isFavorite": false
  },
  {
    "id": "v_simeon_gh",
    "name": "Simeon (West African / Ghanaian English)",
    "description": "Gentle, articulate Ghanaian English accent for Sunday school recitations and peaceful prayer devotionals.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Simeon",
    "gender": "MALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alioth",
    "language": "en-GH",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alioth.mp3",
    "status": "ACTIVE",
    "tags": [
      "Ghanaian Accent",
      "West African",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_keziah_ug",
    "name": "Keziah (East African / Ugandan English)",
    "description": "Melodic, warm Ugandan English delivery ideal for women fellowship broadcasts and missionary updates.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Keziah",
    "gender": "FEMALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Megrez",
    "language": "en-UG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Megrez.mp3",
    "status": "ACTIVE",
    "tags": [
      "Ugandan Accent",
      "East African",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_kofi_gh",
    "name": "Kofi (West African Exhortation)",
    "description": "Passionate West African delivery with clarity and warmth for revival prayer alerts.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Kofi",
    "gender": "MALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Mizar",
    "language": "en-GH",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Mizar.mp3",
    "status": "ACTIVE",
    "tags": [
      "Ghanaian Accent",
      "Exhortation",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_amara_ng",
    "name": "Amara (Nigerian Warm Devotional)",
    "description": "Rich, encouraging Nigerian English cadence designed for mothers prayers and morning scripture.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Amara",
    "gender": "FEMALE",
    "accent": "Nigerian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alkaid",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alkaid.mp3",
    "status": "ACTIVE",
    "tags": [
      "Nigerian Accent",
      "Warm Devotional",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_chidi_ng",
    "name": "Chidi (Nigerian Faith & Victory)",
    "description": "Confident, victorious Nigerian male cadence for faith declarations and spiritual warfare prayers.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Chidi",
    "gender": "MALE",
    "accent": "Nigerian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Kochab",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Kochab.mp3",
    "status": "ACTIVE",
    "tags": [
      "Nigerian Accent",
      "Faith",
      "Victory",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_zola_za",
    "name": "Zola (South African Gospel Exhortation)",
    "description": "Joyful, uplifting South African cadence for praise reports and gospel fellowship.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Zola",
    "gender": "FEMALE",
    "accent": "South African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Pherkad",
    "language": "en-ZA",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Pherkad.mp3",
    "status": "ACTIVE",
    "tags": [
      "South African Accent",
      "Gospel",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_tendai_zw",
    "name": "Tendai (Southern African / Zimbabwean)",
    "description": "Thoughtful, compassionate Southern African delivery for counselling messages and hospital visit audios.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Tendai",
    "gender": "MALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Eltanin",
    "language": "en-ZW",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Eltanin.mp3",
    "status": "ACTIVE",
    "tags": [
      "Zimbabwean Accent",
      "Compassion",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_eniola_ng",
    "name": "Eniola (Nigerian Youth Ministry)",
    "description": "Vibrant, energetic Nigerian female delivery for campus fellowship announcements and youth conferences.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Eniola",
    "gender": "FEMALE",
    "accent": "Nigerian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Rastaban",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Rastaban.mp3",
    "status": "ACTIVE",
    "tags": [
      "Nigerian Accent",
      "Youth Ministry",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_kwame_gh",
    "name": "Kwame (Ghanaian Academic & Lector)",
    "description": "Scholarly, articulate West African reader for theological lectures and seminary recaps.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Kwame",
    "gender": "MALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Grumium",
    "language": "en-GH",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Grumium.mp3",
    "status": "ACTIVE",
    "tags": [
      "Ghanaian Accent",
      "Theological",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_wanjiku_ke",
    "name": "Wanjiku (Kenyan Praise & Thanksgiving)",
    "description": "Bright, grateful Kenyan delivery for harvest thanksgiving announcements and choir recitals.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Wanjiku",
    "gender": "FEMALE",
    "accent": "Kenyan",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "KumaA",
    "language": "en-KE",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/KumaA.mp3",
    "status": "ACTIVE",
    "tags": [
      "Kenyan Accent",
      "Thanksgiving",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_babatunde_ng",
    "name": "Babatunde (Nigerian Resonant Lector)",
    "description": "Deep, resonant Nigerian voice with dignified gravitas for formal scripture recitations.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Babatunde",
    "gender": "MALE",
    "accent": "Nigerian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alwaid",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alwaid.mp3",
    "status": "ACTIVE",
    "tags": [
      "Nigerian Accent",
      "Gravitas",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_nkechi_ng",
    "name": "Nkechi (Nigerian Contemplative Prayer)",
    "description": "Calm, peaceful Igbo-inflected Nigerian cadence for quiet meditation and night vigil prayers.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Nkechi",
    "gender": "FEMALE",
    "accent": "Nigerian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alsafi",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alsafi.mp3",
    "status": "ACTIVE",
    "tags": [
      "Nigerian Accent",
      "Contemplative",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_thabo_za",
    "name": "Thabo (South African Youth Exhortation)",
    "description": "Inspiring, modern South African English voice for youth rallies and community outreach.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Thabo",
    "gender": "MALE",
    "accent": "South African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Kraz",
    "language": "en-ZA",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Kraz.mp3",
    "status": "ACTIVE",
    "tags": [
      "South African Accent",
      "Youth",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_blessing_af",
    "name": "Blessing (African Community Inspiration)",
    "description": "Uplifting African female voice bringing joyful encouragement to women fellowships across the continent.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Blessing",
    "gender": "FEMALE",
    "accent": "African",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Gienah",
    "language": "en-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Gienah.mp3",
    "status": "ACTIVE",
    "tags": [
      "African Accent",
      "Community",
      "Inspiration",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_emmanuel_pcm",
    "name": "Emmanuel (West African Pidgin & English)",
    "description": "Authentic West African Pidgin English narration for grassroots evangelism, street ministry, and vibrant community fellowship.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Emmanuel",
    "gender": "MALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Chiron",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Chiron.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "West African Pidgin",
      "Gemini 3.8 Flash TTS",
      "Grassroots",
      "Engaging"
    ],
    "isFavorite": false
  },
  {
    "id": "v_elijah_pcm",
    "name": "Elijah (West African Pidgin Proclamation)",
    "description": "Bold, passionate West African Pidgin delivery for crusade invitations, revival announcements, and outdoor preaching.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Elijah",
    "gender": "MALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Achird",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Achird.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "West African Pidgin",
      "Gemini 3.8 Flash TTS",
      "Bold",
      "Proclamation"
    ],
    "isFavorite": true
  },
  {
    "id": "v_blessing_pcm",
    "name": "Blessing (West African Pidgin Fellowship)",
    "description": "Warm, welcoming West African Pidgin voice for women fellowship announcements, marketplace devotionals, and church greetings.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Blessing",
    "gender": "FEMALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alcmene",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alcmene.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "West African Pidgin",
      "Gemini 3.8 Flash TTS",
      "Warm",
      "Fellowship"
    ],
    "isFavorite": false
  },
  {
    "id": "v_barnabas_pcm",
    "name": "Barnabas (West African Pidgin Exhortation)",
    "description": "Relatable and vibrant Pidgin English voice encouraging believers in community groups and street outreach.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Barnabas",
    "gender": "MALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Markab",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Markab.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "West African Pidgin",
      "Gemini 3.8 Flash TTS",
      "Exhortation"
    ],
    "isFavorite": false
  },
  {
    "id": "v_john_pcm",
    "name": "John (West African Pidgin Parables)",
    "description": "Engaging, story-telling Pidgin cadence for Bible parables, drama audios, and children ministry.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "John",
    "gender": "MALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Algorab",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Algorab.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Storytelling",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": true
  },
  {
    "id": "v_dorcas_pcm",
    "name": "Dorcas (West African Pidgin Marketplace)",
    "description": "Marketplace-friendly, down-to-earth Pidgin voice for everyday Christian encouragement.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Dorcas",
    "gender": "FEMALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Minkar",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Minkar.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Marketplace",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_peter_pcm",
    "name": "Peter (West African Pidgin Crusade Reader)",
    "description": "High-energy, crusade-ready Pidgin delivery for soul-winning alerts and church invites.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Peter",
    "gender": "MALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Sargas",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Sargas.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Crusade",
      "High Energy",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_mary_pcm",
    "name": "Mary (West African Pidgin Mothers Prayer)",
    "description": "Loving, prayerful Pidgin delivery for family morning prayers and intercessory gatherings.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Mary",
    "gender": "FEMALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Shaula",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Shaula.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Prayer",
      "Family",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": true
  },
  {
    "id": "v_paul_pcm",
    "name": "Paul (West African Pidgin Street Outreach)",
    "description": "Bold, street-smart Pidgin voice communicating the Gospel simply and directly to youths.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Paul",
    "gender": "MALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Girtab",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Girtab.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Youth",
      "Street Ministry",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_joy_pcm",
    "name": "Joy (West African Pidgin Praise & Testimony)",
    "description": "Radiant, celebratory Pidgin voice for sharing testimony audio clips and praise reports.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Joy",
    "gender": "FEMALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Jabbah",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Jabbah.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Testimonies",
      "Praise",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_joshua_pcm",
    "name": "Joshua (West African Pidgin Youth Fire)",
    "description": "Passionate, energetic young male Pidgin voice calling generation Z to revival.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Joshua",
    "gender": "MALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Akrab",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Akrab.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Revival",
      "Youth",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": true
  },
  {
    "id": "v_grace_pcm",
    "name": "Grace (West African Pidgin Morning Joy)",
    "description": "Comforting, serene Pidgin voice delivering morning devotional bread and encouragement.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Grace",
    "gender": "FEMALE",
    "accent": "West African Pidgin",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Dschubba",
    "language": "pcm-NG",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Dschubba.mp3",
    "status": "ACTIVE",
    "tags": [
      "Pidgin Accent",
      "Devotional Bread",
      "Joy",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_thomas_in",
    "name": "Thomas (Indian English Scripture Orator)",
    "description": "Articulate, reverent Indian English cadence suitable for Scripture readings, theological lectures, and devotionals.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Thomas",
    "gender": "MALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Encke",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Encke.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Scripture Reading",
      "Articulate",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_priya_in",
    "name": "Priya (Indian English Devotional)",
    "description": "Warm, melodic Indian English voice for daily morning prayer, children ministry stories, and devotional reflections.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Priya",
    "gender": "FEMALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Daphne",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Daphne.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Devotional",
      "Melodic",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_aaron_in",
    "name": "Aaron (Indian English Prayer & Care)",
    "description": "Compassionate, gentle Indian English delivery for grief counseling messages, hospital prayers, and family benedictions.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Aaron",
    "gender": "MALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Pollux",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Pollux.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Prayer & Care",
      "Comforting",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_luke_in",
    "name": "Luke (Indian English Teaching & Gospel)",
    "description": "Clear, articulate Indian English voice for Gospel exposition, discipleship audio, and Bible study series.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Luke",
    "gender": "MALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Deneb",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Deneb.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Teaching",
      "Gospel",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_martha_in",
    "name": "Martha (Indian English Community & Service)",
    "description": "Warm, hospitable Indian English voice for church service announcements, community projects, and prayer circles.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Martha",
    "gender": "FEMALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Sirius",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Sirius.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Community",
      "Service",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_silas_in",
    "name": "Silas (Indian English Theological Lector)",
    "description": "Dignified Indian academic delivery for systematic theology recaps and Christian ethics lectures.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Silas",
    "gender": "MALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Kaus",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Kaus.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Theological",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_naomi_in",
    "name": "Naomi (Indian English Evening Benediction)",
    "description": "Soothing Indian female cadence for bedtime family prayers and tranquil evening reflections.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Naomi",
    "gender": "FEMALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alnasl",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alnasl.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Benediction",
      "Soothing",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_devadas_in",
    "name": "Devadas (Indian English Cathedral Orator)",
    "description": "Stately and solemn Indian English voice for cathedral readings and solemn ordination services.",
    "categoryId": "cat_ultra",
    "categoryName": "Ultra-Expressive",
    "creditMultiplier": 3.5,
    "speakerName": "Devadas",
    "gender": "MALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Nunki",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Nunki.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Cathedral",
      "Solemn",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_ananya_in",
    "name": "Ananya (Indian English Youth Fellowship)",
    "description": "Bright, youthful Indian female voice engaging university students and youth ministry fellowship.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Ananya",
    "gender": "FEMALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Ascella",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Ascella.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Youth",
      "Bright",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_samuel_in",
    "name": "Samuel (Indian English Gospel Broadcast)",
    "description": "Inspiring, broadcast-grade Indian delivery for radio broadcasts and community outreach podcasts.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Samuel",
    "gender": "MALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Albaldah",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Albaldah.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Broadcast",
      "Radio",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_sunita_in",
    "name": "Sunita (Indian English Healing Prayer)",
    "description": "Gentle, faith-filled Indian female delivery for hospital visits and healing scripture readings.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Sunita",
    "gender": "FEMALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Kowkab",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Kowkab.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Healing Prayer",
      "Faith",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_benjamin_in",
    "name": "Benjamin (Indian English Scripture Exhortation)",
    "description": "Energetic, persuasive Indian male delivery for church missions and stewardship appeals.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Benjamin",
    "gender": "MALE",
    "accent": "Indian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Polis",
    "language": "en-IN",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Polis.mp3",
    "status": "ACTIVE",
    "tags": [
      "Indian Accent",
      "Exhortation",
      "Missions",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_mateo_es",
    "name": "Mateo (Spanish & Multilingual Devocional)",
    "description": "Expressive Hispanic/Spanish devotional delivery with multilingual flexibility powered by Gemini 3.8 Flash TTS.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Mateo",
    "gender": "MALE",
    "accent": "Spanish",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Orpheus",
    "language": "es-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Orpheus.mp3",
    "status": "ACTIVE",
    "tags": [
      "Spanish Accent",
      "Gemini 3.8 Flash TTS",
      "Multilingual Preserved",
      "Reverent"
    ],
    "isFavorite": false
  },
  {
    "id": "v_santiago_es",
    "name": "Santiago (Spanish Latin American Lectura)",
    "description": "Reverent Latin American Spanish voice for scripture readings, parish bulletins, and liturgical prayers.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Santiago",
    "gender": "MALE",
    "accent": "Spanish",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Mirzam",
    "language": "es-MX",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Mirzam.mp3",
    "status": "ACTIVE",
    "tags": [
      "Spanish Accent",
      "Latin American",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_sofia_es",
    "name": "Sofia (Spanish Contemplativa)",
    "description": "Calm, meditative Spanish female voice for devotional reflections and prayer vigils.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Sofia",
    "gender": "FEMALE",
    "accent": "Spanish",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Adhara",
    "language": "es-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Adhara.mp3",
    "status": "ACTIVE",
    "tags": [
      "Spanish Accent",
      "Contemplativa",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_valentina_es",
    "name": "Valentina (Spanish Oración Matutina)",
    "description": "Warm, clear Spanish female delivery for morning prayer and family scripture devotionals.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Valentina",
    "gender": "FEMALE",
    "accent": "Spanish",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Furud",
    "language": "es-ES",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Furud.mp3",
    "status": "ACTIVE",
    "tags": [
      "Spanish Accent",
      "Oración",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_jean_fr",
    "name": "Jean (French African Évangélisation)",
    "description": "Passionate Francophone African voice for cross-border evangelism and Sunday worship in West & Central Africa.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Jean",
    "gender": "MALE",
    "accent": "French",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Wezen",
    "language": "fr-FR",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Wezen.mp3",
    "status": "ACTIVE",
    "tags": [
      "French Accent",
      "Francophone Africa",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_marie_fr",
    "name": "Marie (French Méditation Chrétienne)",
    "description": "Gentle, contemplative French female voice for Christian meditation, prayer retreats, and scripture reading.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Marie",
    "gender": "FEMALE",
    "accent": "French",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Aludra",
    "language": "fr-FR",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Aludra.mp3",
    "status": "ACTIVE",
    "tags": [
      "French Accent",
      "Méditation",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_luc_fr",
    "name": "Luc (French Lector de la Bible)",
    "description": "Articulate, reverent French male voice for reading the Gospels and church bulletins.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Luc",
    "gender": "MALE",
    "accent": "French",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Naos",
    "language": "fr-FR",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Naos.mp3",
    "status": "ACTIVE",
    "tags": [
      "French Accent",
      "Lector",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_mateus_pt",
    "name": "Mateus (Portuguese Brazilian Devocional)",
    "description": "Warm, vibrant Brazilian Portuguese voice for church announcements, discipleship podcasts, and music intros.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Mateus",
    "gender": "MALE",
    "accent": "Portuguese",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Suhail",
    "language": "pt-BR",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Suhail.mp3",
    "status": "ACTIVE",
    "tags": [
      "Portuguese Accent",
      "Brazil",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_ana_pt",
    "name": "Ana (Portuguese Oração e Louvor)",
    "description": "Devout, melodic Portuguese female voice for prayer meetings, communion reflections, and worship announcements.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Ana",
    "gender": "FEMALE",
    "accent": "Portuguese",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Avior",
    "language": "pt-BR",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Avior.mp3",
    "status": "ACTIVE",
    "tags": [
      "Portuguese Accent",
      "Oração",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_paulo_pt",
    "name": "Paulo (Portuguese African Leitura)",
    "description": "Deep, steady Lusophone African voice for scripture reading in Angola, Mozambique, and Cape Verde.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Paulo",
    "gender": "MALE",
    "accent": "Portuguese",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Aspidiske",
    "language": "pt-PT",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Aspidiske.mp3",
    "status": "ACTIVE",
    "tags": [
      "Portuguese Accent",
      "Africa",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_baraka_sw",
    "name": "Baraka (Swahili East African Neno)",
    "description": "Inspiring, resonant Swahili delivery for East African church broadcasts, crusades, and Bible readings.",
    "categoryId": "cat_premium",
    "categoryName": "Premium Natural",
    "creditMultiplier": 2,
    "speakerName": "Baraka",
    "gender": "MALE",
    "accent": "Swahili",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Miaplacidus",
    "language": "sw-KE",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Miaplacidus.mp3",
    "status": "ACTIVE",
    "tags": [
      "Swahili Accent",
      "East Africa",
      "Neno la Mungu",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_zawadi_sw",
    "name": "Zawadi (Swahili Sala ya Asubuhi)",
    "description": "Joyful, uplifting Swahili female voice for morning devotionals and women fellowship gatherings.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Zawadi",
    "gender": "FEMALE",
    "accent": "Swahili",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Tureis",
    "language": "sw-TZ",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Tureis.mp3",
    "status": "ACTIVE",
    "tags": [
      "Swahili Accent",
      "Tanzania",
      "Sala",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_caleb_au",
    "name": "Caleb (Australian Community Fellowship)",
    "description": "Bright, welcoming Australian accent for community outreach, fellowship lunches, and church family news.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Caleb",
    "gender": "MALE",
    "accent": "Australian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Zephyr",
    "language": "en-AU",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Zephyr.mp3",
    "status": "ACTIVE",
    "tags": [
      "Australian Accent",
      "Gemini 3.8 Flash TTS",
      "Community",
      "Friendly"
    ],
    "isFavorite": false
  },
  {
    "id": "v_liam_au",
    "name": "Liam (Australian Youth Exhortation)",
    "description": "Down-to-earth, energetic Australian voice for youth camps and beach outreach ministries.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Liam",
    "gender": "MALE",
    "accent": "Australian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Markeb",
    "language": "en-AU",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Markeb.mp3",
    "status": "ACTIVE",
    "tags": [
      "Australian Accent",
      "Youth",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_johannes_de",
    "name": "Johannes (German Scripture Reading)",
    "description": "Structured, reverent German voice for classical Martin Luther Bible reading and chorale intros.",
    "categoryId": "cat_standard",
    "categoryName": "Standard Voices",
    "creditMultiplier": 1,
    "speakerName": "Johannes",
    "gender": "MALE",
    "accent": "German",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "STOCK",
    "provider": "GOOGLE_CLOUD",
    "providerVoiceId": "Alphecca",
    "language": "de-DE",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/google/Alphecca.mp3",
    "status": "ACTIVE",
    "tags": [
      "German Accent",
      "Luther Bible",
      "Gemini 3.8 Flash TTS"
    ],
    "isFavorite": false
  },
  {
    "id": "v_john_clone",
    "name": "John Mark (Authorized Leadership Clone)",
    "description": "Authorized custom voice replica of John Mark for church communications.",
    "categoryId": "cat_cloned",
    "categoryName": "Leadership Voice Clones",
    "creditMultiplier": 5,
    "speakerName": "John",
    "gender": "MALE",
    "accent": "American",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "CLONED",
    "provider": "ELEVENLABS",
    "providerVoiceId": "cloned_voice_pastor_john_01",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/elevenlabs/cloned_voice_pastor_john_01.mp3",
    "status": "ACTIVE",
    "tags": [
      "American Accent",
      "Leadership Clone",
      "Authorized"
    ],
    "isFavorite": false
  },
  {
    "id": "v_emmanuel_clone",
    "name": "Emmanuel (Authorized Leadership Clone)",
    "description": "Authorized clone of Emmanuel with Nigerian cadence for youth devotionals.",
    "categoryId": "cat_cloned",
    "categoryName": "Leadership Voice Clones",
    "creditMultiplier": 5,
    "speakerName": "Emmanuel",
    "gender": "MALE",
    "accent": "Nigerian",
    "accentCapability": "MULTILINGUAL_PRESERVED",
    "type": "CLONED",
    "provider": "ELEVENLABS",
    "providerVoiceId": "cloned_voice_emmanuel_01",
    "language": "en-US",
    "sampleAudioUrl": "https://safe-ai-assets-staging.r2.cloudflarestorage.com/voices/samples/elevenlabs/cloned_voice_emmanuel_01.mp3",
    "status": "ACTIVE",
    "tags": [
      "Nigerian Accent",
      "Leadership Clone",
      "Authorized"
    ],
    "isFavorite": false
  }
];

export const MOCK_GENERATIONS: AudioGeneration[] = [
  {
    id: 'gen_101',
    tenantId: 'ten_grace-church',
    title: 'Romans 8:38-39 Expository Recap',
    script:
      'For I am convinced that neither death nor life, neither angels nor demons, neither the present nor the future, nor any powers, will be able to separate us from the love of God that is in Christ Jesus our Lord.',
    voiceId: 'v_david_scripture',
    voiceName: 'David (American Reflective Scripture)',
    categoryName: 'Premium Natural',
    creditMultiplier: 2.0,
    creditsBurned: 450,
    provider: 'ELEVENLABS',
    useCase: 'DEVOTIONAL',
    status: 'COMPLETED',
    progress: 100,
    audioUrl: 'https://actions.google.com/sounds/v1/ambiences/gentle_morning_birds.ogg',
    durationSeconds: 28,
    characterCount: 225,
    estimatedCostUsd: 0.034,
    scripturesDetected: ['Romans 8:38-39'],
    createdAt: '2026-09-25T14:30:00Z',
    completedAt: '2026-09-25T14:30:12Z',
  },
  {
    id: 'gen_102',
    tenantId: 'ten_grace-church',
    title: 'Psalm 23 Morning Liturgy',
    script:
      'The Lord is my shepherd; I shall not want. He makes me lie down in green pastures. He leads me beside still waters. He restores my soul.',
    voiceId: 'v_ruth_devotional',
    voiceName: 'Ruth (American Calm Devotional)',
    categoryName: 'Premium Natural',
    creditMultiplier: 2.0,
    creditsBurned: 135,
    provider: 'GOOGLE_CLOUD',
    useCase: 'LITURGY',
    status: 'COMPLETED',
    progress: 100,
    audioUrl: 'https://actions.google.com/sounds/v1/ambiences/gentle_morning_birds.ogg',
    durationSeconds: 19,
    characterCount: 135,
    estimatedCostUsd: 0.002,
    scripturesDetected: ['Psalm 23:1-3'],
    createdAt: '2026-09-24T09:15:00Z',
    completedAt: '2026-09-24T09:15:08Z',
  },
];

export const MOCK_AUDIT_LOGS: AuditLog[] = [
  {
    id: 'aud_1',
    action: 'VOICE_RENAMED',
    actorEmail: 'admin@doxatech.com',
    actorRole: 'SUPER_ADMIN',
    resourceId: 'v_david_scripture',
    details: 'Super Admin updated voice display name to "David (American Reflective Scripture)" and assigned to Premium Natural.',
    ipAddress: '192.168.1.1',
    timestamp: '2026-09-25T12:00:00Z',
  },
  {
    id: 'aud_2',
    action: 'GENERATION_COMPLETED',
    actorEmail: 'pastor.john@gracechurch.org',
    actorRole: 'ADMIN',
    resourceId: 'gen_101',
    details: 'Audio generated (225 chars, 450 credits burned).',
    ipAddress: '192.168.1.42',
    timestamp: '2026-09-25T14:30:12Z',
  },
];

export const SCRIPTURE_PRESETS = [
  {
    title: 'Romans 8:38-39 (Devotional)',
    useCase: 'DEVOTIONAL' as const,
    text: 'For I am convinced that neither death nor life, neither angels nor demons, neither the present nor the future, nor any powers, will be able to separate us from the love of God that is in Christ Jesus our Lord. Romans 8:38-39.',
  },
  {
    title: 'Psalm 23:1-3 (Liturgy)',
    useCase: 'LITURGY' as const,
    text: 'The Lord is my shepherd; I shall not want. He makes me lie down in green pastures. He leads me beside still waters. He restores my soul. He leads me in paths of righteousness for his name\'s sake. Psalm 23:1-3.',
  },
  {
    title: 'Philippians 4:6-7 (Prayer)',
    useCase: 'PRAYER' as const,
    text: 'Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God. And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus. Philippians 4:6-7.',
  },
  {
    title: 'Ephesians 2:8-10 (Sermon Recap)',
    useCase: 'SERMON_RECAP' as const,
    text: 'This past Sunday, we explored Ephesians 2:8-10 and discovered how grace reshapes our daily vocation. We are God\'s handiwork, created in Christ Jesus to do good works which God prepared in advance for us.',
  },
  {
    title: 'Wednesday Community Night (Announcements)',
    useCase: 'ANNOUNCEMENT' as const,
    text: 'Good morning, church family! Join us this Wednesday evening at 6:30 PM for our community prayer night and youth ministry fellowship in the main chapel.',
  },
];

